import { doRequest } from 'Request';
import { ALKLocationResponse } from 'shared/types/postcodeResults';

export const getOpenReachAddressForALK = (alk: string): Promise<ALKLocationResponse> => {
  return doRequest({
    path: `/alk/${alk}`,
  });
};
